function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from "react";
import throttle from "lodash/throttle";
import cx from "classnames";
var classPrefix = "tc-button";
var Button = function Button(props) {
  var _cx;
  var children = props.children,
    className = props.className,
    disabled = props.disabled,
    type = props.type,
    style = props.style,
    onClick = props.onClick,
    size = props.size,
    throttleSecond = props.throttleSecond,
    round = props.round,
    fill = props.fill,
    block = props.block,
    _props$fixed = props.fixed,
    fixed = _props$fixed === void 0 ? false : _props$fixed,
    description = props.description;
  var baseProps = {
    disabled: disabled,
    style: style,
    className: cx(classPrefix, className, ["".concat(classPrefix, "-").concat(type)], ["".concat(classPrefix, "-").concat(size)], (_cx = {}, _defineProperty(_cx, "".concat(classPrefix, "-fill-outline"), fill === "outline"), _defineProperty(_cx, "".concat(classPrefix, "-round"), round), _defineProperty(_cx, "".concat(classPrefix, "-disabled"), disabled), _defineProperty(_cx, "".concat(classPrefix, "-block"), block), _defineProperty(_cx, "".concat(classPrefix, "-fixed"), fixed), _cx))
  };
  return /*#__PURE__*/React.createElement("button", Object.assign({}, baseProps, {
    type: 'button',
    onClick: throttle(function (e) {
      if (!!onClick) {
        onClick(e);
      }
    }, throttleSecond)
  }), /*#__PURE__*/React.createElement("span", {
    className: "".concat(classPrefix, "-content")
  }, children), !!description && /*#__PURE__*/React.createElement("span", {
    className: "".concat(classPrefix, "-description")
  }, description));
};
Button.defaultProps = {
  size: "large",
  type: "default",
  disabled: false,
  throttleSecond: 0,
  block: false,
  fixed: false,
  round: true
};
export default Button;